import React, { Component } from 'react';
import { Paper, Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui';
import { Theme } from '../../theme/theme';
import { LoginForm } from './login-form.container';

const styles = {
  logo: {
    maxWidth: 100,
    marginBottom: 30,
  },
  toolbar: {
    backgroundColor: Theme.SECONDARY_COLOR,
  },
  parent: {
    textAlign: 'center',
    backgroundColor: Theme.PRIMARY_COLOR,
    width: '100%',
    height: '100%',
    paddingTop: 50,
  },
  formContainer: {
    height: 330,
    width: 400,
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
  },
};

export class LoginPage extends Component {
  render() {
    return (
      <div style={styles.parent}>
        <div style={{ fontSize: 32, fontWeight: 'bold', color: '#fff', marginBottom: 16 }}>YOCAS</div>
        <Paper style={styles.formContainer} zDepth={3}>
          <Toolbar style={styles.toolbar}>
            <ToolbarGroup>
              <ToolbarTitle text="Login to Yocas" />
            </ToolbarGroup>
          </Toolbar>
          <LoginForm />
        </Paper>
      </div>
    );
  }
}
